/**
 *
 * CheckoutStep1Page
 *
 */

import messages from 'containers/CheckoutPage/messages';
import React, { Fragment, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { compose, Dispatch } from 'redux';
import { createStructuredSelector } from 'reselect';
import translations from 'translations';

import CheckoutStep1 from 'components/Checkout/CheckoutStep1';
import { push } from 'connected-react-router';
import { applyVoucher, getVouchers, goToStep } from 'containers/CheckoutPage/actions';
import { VOUCHER_STATUS } from 'containers/CheckoutPage/constants';
import {
  selectCheckout,
  selectCurrentAppliedVoucher,
  selectDiscountedValue,
  selectVoucherStatus,
} from 'containers/CheckoutPage/selectors';
import { ICheckout } from 'containers/CheckoutPage/types';
import { refreshCart, setProductNote, updateProductQuantity } from 'containers/MainLayout/actions';
import { selectCart, selectOrderDisabled } from 'containers/MainLayout/selectors';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { OrderDisabledReason, ProductNoteInput, Voucher } from 'types/schema';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { selectVoucherLoading } from '../CheckoutPage/selectors';
import { removeAllProduct } from './actions';
import reducer from './reducer';
import saga from './saga';
import selectCheckoutStep1Page from './selectors';
import { RootState } from './types';

interface OwnProps {
  cart: any;
  checkout: ICheckout;
  orderDisabled: {
    orderDisabled: boolean;
    message: string;
    reason?: OrderDisabledReason;
  };
  checkoutstep1page: any;
  currentAppliedVoucher: Voucher | null;
  voucherStatus: VOUCHER_STATUS | null;
  discountedValue: number;
  voucherLoading: boolean;
}

interface StateProps {}

interface DispatchProps {
  onApplyVoucher: (data: any) => void;
  onGetVouchers: (data: any) => void;
  onGoToDeliveryDetails: () => void;
  onCancelCheckout: () => void;
  onUpdateProductQuantity: (data: any) => void;
  onRemoveAllProduct: (data: any) => void;
  setProductNote: (data: ProductNoteInput) => void;
  refreshCart: () => void;
}

type Props = StateProps & DispatchProps & OwnProps & RouteComponentProps;

const CheckoutStep1Page: React.FC<Props> = ({
  cart,
  checkout,
  onUpdateProductQuantity,
  onRemoveAllProduct,
  onCancelCheckout,
  onGoToDeliveryDetails,
  orderDisabled,
  checkoutstep1page,
  setProductNote,
  onApplyVoucher,
  onGetVouchers,
  currentAppliedVoucher,
  voucherStatus,
  discountedValue,
  voucherLoading,
  history,
  refreshCart,
}) => {
  const _onRemoveProduct = (data: any) => {
    onUpdateProductQuantity(data);
  };
  const _onRemoveAllProduct = (data: any) => {
    onRemoveAllProduct(data);
  };
  useEffect(() => {
    refreshCart();
  }, []);
  return (
    <Fragment>
      <Helmet>
        <title>{translations(messages.headerStep1)}</title>
        <meta name="description" content={`${translations(messages.headerStep1)}`} />
      </Helmet>
      <CheckoutStep1
        notAvailableProducts={cart.notAvailableProducts}
        onRemoveCartItem={_onRemoveProduct}
        onRemoveCartAllItem={_onRemoveAllProduct}
        onCancelCheckout={onCancelCheckout}
        onGoToDeliveryDetails={onGoToDeliveryDetails}
        checkout={checkout}
        cart={cart}
        orderDisabled={orderDisabled.orderDisabled}
        orderDisabledMessage={orderDisabled.message}
        setProductNote={setProductNote}
        noteItemLoading={checkoutstep1page?.noteItemLoading}
        deliveryFee={cart.deliveryFee}
        loading={cart?.loading}
        currentAppliedVoucher={currentAppliedVoucher}
        voucherStatus={voucherStatus}
        discountedValue={discountedValue}
        onApplyVoucher={onApplyVoucher}
        getVouchers={onGetVouchers}
        voucherLoading={voucherLoading}
        isFromInvalidPopup={history.action === 'REPLACE'}
      />
    </Fragment>
  );
};

const mapStateToProps = createStructuredSelector<RootState, StateProps>({
  checkoutstep1page: selectCheckoutStep1Page(),
  cart: selectCart(),
  checkout: selectCheckout(),
  orderDisabled: selectOrderDisabled(),
  currentAppliedVoucher: selectCurrentAppliedVoucher(),
  voucherStatus: selectVoucherStatus(),
  discountedValue: selectDiscountedValue(),
  voucherLoading: selectVoucherLoading(),
});

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
  return {
    onApplyVoucher: (data: string) => dispatch(applyVoucher(data)),
    onGetVouchers: (data: any) => dispatch(getVouchers(data)),
    onGoToDeliveryDetails: () => dispatch(goToStep(2)),
    onCancelCheckout: () => dispatch(push('/market')),
    onUpdateProductQuantity: (data: any) => dispatch(updateProductQuantity({ ...data, quantity: 0 })),
    onRemoveAllProduct: (data: any) => dispatch(removeAllProduct(data)),
    setProductNote: (data) => dispatch(setProductNote(data)),
    refreshCart: () => dispatch(refreshCart()),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withRouterComponent = withRouter(CheckoutStep1Page as any);

// <OwnProps> restricts access to the HOC's other props. This component must not do anything with reducer hoc
const withReducer = injectReducer<OwnProps>({
  key: 'checkoutStep1Page',
  reducer: reducer,
});
// <OwnProps> restricts access to the HOC's other props. This component must not do anything with saga hoc
const withSaga = injectSaga<OwnProps>({ key: 'checkoutStep1Page', saga: saga });

export default compose(withReducer, withSaga, withConnect)(withRouterComponent);
